import { render } from "./SemaforoSectores.vue?vue&type=template&id=008726b4&scoped=true"
import script from "./SemaforoSectores.vue?vue&type=script&lang=js"
export * from "./SemaforoSectores.vue?vue&type=script&lang=js"

import "./SemaforoSectores.vue?vue&type=style&index=0&id=008726b4&scoped=true&lang=css"

import exportComponent from "/var/www/html/genesis-git/vue-genesis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-008726b4"]])

export default __exports__